import React from 'react';
import { ReactComponent as DragIcon } from 'assets/images/icons/question-design/drag-question.svg';
import { Box, Stack } from '@mui/material';
import {
    IQuestionBaseProps,
    IQuestionNewEditForm,
} from 'types/campaign-design';

const QuestionNoContent: React.FC<IQuestionBaseProps> = ({
    question,
    onDragStart,
    onDragOver,
    onDrop,
}) => {
    return (
        <Box>
            <Stack p={'0px 35px 35px 35px'} gap={1}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 6 }}>
                    <Box
                        sx={{ marginTop: '10px' }}
                        draggable={true}
                        onDragStart={(event) =>
                            onDragStart &&
                            onDragStart(event, question as IQuestionNewEditForm)
                        }
                        onDragOver={(event) =>
                            onDragOver &&
                            onDragOver(event, question as IQuestionNewEditForm)
                        }
                        onDrop={(event) =>
                            onDrop &&
                            onDrop(event, question as IQuestionNewEditForm)
                        }
                    >
                        {!question?.setting_logic && <DragIcon />}
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
};

export default QuestionNoContent;
